import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default (props: SvgIconProps) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M16 5.985H6v11.97h10V20H6.03a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2H16v1.985z" />
    <path d="M16.174 9.128l1.209-1.269 4.11 4.11-4.11 4.112-1.21-1.21L18 13H8.98v-2H18l-1.826-1.872z" />
  </SvgIcon>
);
